import { useTranslation } from 'react-i18next'

import { useAuth, useAuthFlow } from '@features/auth'

import { useCategoriesModal } from '@widgets/modal-categories/hooks/useCategoriesModal'

import { CART_FEATURES } from '@shared/contants'
import { cn } from '@shared/lib/cn'
import Button from '@shared/ui/button'

import styles from './styles.module.scss'

interface EmptyCartProps {
  className?: string;
}

export default function EmptyCart ({ className }: EmptyCartProps) {
  const { t: tca } = useTranslation('cart')
  const { t: tc } = useTranslation('common')
  const { t: ta } = useTranslation('auth')
  const { user } = useAuth()
  const authFlow = useAuthFlow()
  const { openModal } = useCategoriesModal()

  return (
    <>
      <div className={cn(styles.root__top, className)}>
        <h2 className={styles.root__title}>
          {tca('empty.title')}
        </h2>
        <p className={styles.root__desc}>
          {tca('empty.after_link')} {tca('empty.search')}
        </p>
        <Button size="large" onClick={() => openModal()}>
          {tc('button.catalog')}
        </Button>
      </div>

      <div className={styles.root__bottom}>
        <div className={styles.root__list}>
          {CART_FEATURES.map((item) => (
            <div key={item.key} className={styles.root__item}>
              <span className={styles.root__icon}>
                <img
                  src={`/icons/cart/features/${item.key}.svg`}
                  alt=""
                  fetchPriority="low"
                  loading="lazy"
                />
              </span>
              {tca(`preview.features.${item.key}`)}
            </div>
          ))}
        </div>

        {!user?.first_name && (
          <Button size="large" theme="secondary" onClick={authFlow}>
            {ta('button.auth')}
          </Button>
        )}
      </div>
    </>
  )
}
